import '../component/Sidebar/Sidebar.css'
import {AdminRoles} from "../context/reducer";

export const RouteInfo = {
    Root: {
        url: "/panel",
        globalUrl: "/panel/",
        name: "داشبورد",
        icon: 'ic-game-play',
        accessRole: []
    }, Dashboard: {
        url: "dashboard",
        globalUrl: "/panel/dashboard",
        name: "داشبورد",
        icon: 'ic_crown',
        accessRole: []
    }, Profile: {
        url: "profile",
        globalUrl: "/panel/profile",
        name: "حساب کاربری",
        icon: 'magazine-icon',
        accessRole: []
    },
    SecondItem: {
        url: "second-item",
        globalUrl: "/panel/second-item",
        name: "نمونه جدول",
        icon: 'ic-game-play',
        accessRole: []
    },
    DefaultListPage: {
        url: "default-list",
        globalUrl: "/panel/default-list",
        name: "لیست پیشفرض",
        icon: 'ic-game-play',
        accessRole: []
    },
    DefaultInputsPage: {
        url: "default-inputs",
        globalUrl: "/panel/default-inputs",
        name: "اینپوت پیشفرض",
        icon: 'ic-game-play',
        accessRole: []
    },
    Category: {
        url: "category",
        globalUrl: "/panel/category",
        name: "دسته بندی",
        icon: 'ic-game-play',
        accessRole: []
    },
    ReleaseDocuments: {
        url: "release-documents",
        globalUrl: "/panel/release-documents",
        name: "اسناد انتشار",
        icon: 'ic-game-play',
        accessRole: []
    },
    Files: {
        url: "file-manager",
        globalUrl: "/panel/file-manager",
        name: "فایل ها",
        icon: 'ic-folders',
        accessRole: ["READ_FILES_LIST"]
    },
    Login: {
        url: "panel/login",
        globalUrl: "/panel/login",
        name: "ورود",
        icon: '',
        accessRole: []
    },
    ForgetPassword: {
        url: "panel/forget-password",
        globalUrl: "/panel/forget-password",
        name: "فراموشی رمز عبور",
        icon: '',
        accessRole: []
    },
    ConfirmPhoneNumber: {
        url: "panel/confirm-phone-number",
        globalUrl: "/panel/confirm-phone-number",
        name: "تایید شماره تماس",
        icon: '',
        accessRole: []
    },
    PasswordRecovery: {
        url: "panel/password-recovery",
        globalUrl: "/panel/password-recovery",
        name: "بازیابی رمز عبور",
        icon: '',
        accessRole: []
    },
    ManagersList: {
        url: "managers-list",
        globalUrl: "/panel/managers-list",
        name: "مدیران",
        icon: "ic-users",
        accessRole: ["READ_ADMINS_LIST"]
    },
    ContactUsList: {
        url: "contact-us-list",
        globalUrl: "/panel/contact-us-list",
        name: "تماس با ما",
        icon: "ic-users",
        accessRole: ["READ_CONTACTS_US_LIST"]
    },
    ManagersDetail: {
        url: "managers-detail/:id",
        globalUrl: "/panel/managers-detail/:id",
        name: "جزئيات مدیر",
        icon: "ic-game-play",
        accessRole: []
    },
    ManagersAccess: {
        url: "managers-access",
        globalUrl: "/panel/managers-access",
        name: "سطح دسترسی",
        icon: "ic-access-level",
        accessRole: ["READ_ADMIN_ROLES_LIST"]
    },
    NewsList: {
        url: "news-list",
        globalUrl: "/panel/news-list",
        name: "اخبار",
        icon: "ic-news",
        accessRole: ["READ_POSTS_LIST"]
    },
    NewsDetail: {
        url: "news-detail/:id",
        globalUrl: "/panel/news-detail/:id",
        name: "جزئیات خبر",
        icon: "ic-news",
        accessRole: []
    },
    SpecialNewsList: {
        url: "special-news-list",
        globalUrl: "/panel/special-news-list",
        name: "اخبار ویژه",
        icon: "ic-special-news",
        accessRole: ["READ_SPECIAL_NEWS_LIST"]
    },
    SpecialNewsDetail: {
        url: "special-news-detail/:id",
        globalUrl: "/panel/special-news-detail/:id",
        name: "جزئیات اخبار ویژه",
        icon: "",
        accessRole: [AdminRoles.SUPER_ADMIN.role]
    },
    SliderList: {
        url: "slider-list",
        globalUrl: "/panel/slider-list",
        name: "اسلایدر ها",
        icon: "ic-slider",
        accessRole: ["READ_SLIDERS_LIST"]
    },
    SliderDetail: {
        url: "slider-detail/:id",
        globalUrl: "/panel/slider-detail/:id",
        name: "اسلایدر ها",
        icon: "ic-slider",
        accessRole: []
    },
    MultiMediaList: {
        url: "multi-media",
        globalUrl: "/panel/multi-media",
        name: "ویدیو ها",
        icon: "ic-multimedia",
        accessRole: ["READ_MULTI_MEDIA_LIST"]
    },
    MultiMediaDetail: {
        url: "multi-media/:id",
        globalUrl: "/panel/multi-media/:id",
        name: "جزئیات ویدئو",
        icon: "",
        accessRole: []
    },
    GalleryList: {
        url: "gallery-list",
        globalUrl: "/panel/gallery-list",
        name: "گالری",
        icon: "ic-gallery",
        accessRole: ["READ_GALLERIES_LIST"]
    },
    GalleryDetail: {
        url: "gallery-detail/:id",
        globalUrl: "/panel/gallery-detail/:id",
        name: "جزئیات گالری",
        icon: "ic-game-play",
        accessRole: []
    },
    AppVersionList: {
        url: "app-version-list",
        globalUrl: "/panel/app-version-list",
        name: "نسخه ها",
        icon: "ic-game-play",
        accessRole: []
    },
    SimpleBarChart: {
        url: "simple-bar-chart",
        globalUrl: "/panel/SimpleBarChart",
        name: "نمودار میله ای ساده",
        icon: "ic-game-play",
        accessRole: []
    },
    PieChartWithPaddingAngle: {
        url: "Pie-chart-with-padding-angle",
        globalUrl: "/panel/Pie-chart-with-padding-angle",
        name: "نمودار دایره ای با فاصله",
        icon: "ic-game-play",
        accessRole: []
    },
    VerticalBarChart: {
        url: "vertical-bar-chart",
        globalUrl: "/panel/vertical-bar-chart",
        name: "نمودار میله ای عمودی",
        icon: "ic-game-play",
        accessRole: []
    },
    SimplePieChart: {
        url: "simple-pie-chart",
        globalUrl: "/panel/simple-pie-chart",
        name: "نمودار دایره ای ساده",
        icon: "ic-game-play",
        accessRole: []
    },
    DoughnutChart: {
        url: "doughnut-chart",
        globalUrl: "/panel/doughnut-chart",
        name: "نمودار دونات",
        icon: "ic-game-play",
        accessRole: []
    },
    PieChart: {
        url: "pie-chart",
        globalUrl: "/panel/pie-chart",
        name: "نمودار دایره ای",
        icon: "ic-game-play",
        accessRole: []
    },
    Charts: {
        url: "chart-sample",
        globalUrl: "/panel/chart-sample",
        name: "نمودارها",
        icon: "ic-game-play",
        accessRole: []
    },
    Exam: {
        url: "Exam",
        globalUrl: "/panel/Exam",
        name: "امتحان",
        icon: "ic-game-play",
        accessRole: []
    },
    Galleries: {
        url: "galleries",
        globalUrl: "/panel/galleries",
        name: "آلبوم عکس",
        icon: "ic-game-play",
        accessRole: []
    },
    VideosDetail: {
        url: "videos-detail/:id",
        globalUrl: "/panel/videos-detail/:id",
        name: "جزئیات ویدئو",
        icon: "",
        accessRole: []
    },

}

